import { Link, NavLink, Outlet } from "react-router-dom";
import { Award, BarChart3, FileBadge, FileText, LayoutGrid, LogOut, Settings, ShieldCheck, Sparkles, Wallet } from "lucide-react";
import { useAuth } from "../lib/auth.js";
import { Button } from "./ui/button.js";
import { cn } from "../lib/utils.js";

const NAV = [
  { to: "/", label: "Workspaces", icon: LayoutGrid, end: true, soon: false },
  { to: "/wallet", label: "My wallet", icon: Wallet, end: false, soon: false },
  { to: "/resumes", label: "Resumes", icon: FileText, end: false, soon: false },
  { to: "/skills", label: "Skills", icon: Sparkles, end: false, soon: false },
  { to: "/cv", label: "Verified CV", icon: FileBadge, end: false, soon: false },
  { to: "/credentials", label: "Credentials", icon: Award, end: false, soon: true },
  { to: "/analytics", label: "Analytics", icon: BarChart3, end: false, soon: false },
  { to: "/account", label: "Account", icon: Settings, end: false, soon: false },
];

/** App shell (UI-STANDARDS §4): 256px left sidebar + 56px top bar + content. */
export function Layout() {
  const { me, logout } = useAuth();
  return (
    <div className="flex min-h-full">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-border bg-card px-3 py-4 lg:flex">
        <Link to="/" className="mb-6 flex items-center gap-2 px-2 font-semibold">
          <ShieldCheck size={20} className="text-primary" />
          Epicredible
        </Link>
        <nav className="flex flex-col gap-1">
          {NAV.map(({ to, label, icon: Icon, end, soon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={(e) => soon && e.preventDefault()}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2 rounded-md px-2 py-2 text-sm font-medium",
                  soon && "cursor-default text-input",
                  isActive && !soon ? "bg-accent text-accent-foreground" : !soon && "text-foreground hover:bg-secondary",
                )
              }
            >
              <Icon size={18} />
              {label}
              {soon && <span className="ml-auto text-[10px] uppercase tracking-wide">soon</span>}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center justify-between border-b border-border bg-card px-6">
          <Link to="/" className="flex items-center gap-2 font-semibold lg:hidden">
            <ShieldCheck size={18} className="text-primary" /> Epicredible
          </Link>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <span className="text-muted-foreground">{me?.user.email}</span>
            <Button variant="secondary" size="sm" onClick={() => void logout()}>
              <LogOut size={16} /> Sign out
            </Button>
          </div>
        </header>
        <main className="mx-auto w-full max-w-[1200px] flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
